import { EncryptedKey, KeyMetadata } from "../types";
import { Preferences } from '@capacitor/preferences'

export function getKeyMetadata(encryptedKey: EncryptedKey): KeyMetadata {
  const { id } = encryptedKey;

  return {
    id,
  };
}

export async function getEncryptedKeys() {

  const prefix = 'ebioro-secure-storage';

  const regexp = RegExp(`^${prefix}\\:(.*)`);
  const keys: EncryptedKey[] = [];

  let allKeys = await getAllKeys()

  for (let i = 0; i < allKeys.keys.length; i++) {
    
    const raw_id = allKeys.keys[i];
      if (raw_id !== null && regexp.test(raw_id)) {
          const key = await getKey(regexp.exec(raw_id)![1],prefix);
         
        if (key !== null) {
          keys.push(key);
        }
      }
  }
  
  return keys;

}

export async function saveEncryptedKeys(keys:EncryptedKey[]){

for (let i=0;i<keys.length;i++){
  await setKey(keys[i].id,keys[i])
}

}

const getKey = async (key: string,prefix:string) => {

  const v = await Preferences.get({ key: `${prefix}:${key}` });

  return v.value ? JSON.parse(v.value) : null;

}

const getAllKeys = async ()=>{
  
  const keys = await Preferences.keys();
  return keys
}

const setKey =async(id: string, key: EncryptedKey) => {
const prefix = 'ebioro-secure-storage';     
return await set(`${prefix}:${id}`, JSON.stringify({ ...key }))

}

const set = async(key: string, value: string) => {
await Preferences.set({ key, value: value })
}